import { render } from "./ks-contacts-modal.vue?vue&type=template&id=0c964cee"
import script from "./ks-contacts-modal.vue?vue&type=script&lang=js"
export * from "./ks-contacts-modal.vue?vue&type=script&lang=js"

import "./ks-contacts-modal.vue?vue&type=style&index=0&id=0c964cee&lang=css"
script.render = render

export default script